import { Outlet } from "react-router-dom";
import { Layout } from "./Layout";
import { OnboardingModal } from "@/components/modals/OnboardingModal";
import { EnhancedAudioPlayer } from "@/components/audio";

/**
 * ProtectedLayout Component
 * 
 * Wraps authenticated pages with the persistent sidebar navigation.
 * Uses React Router's <Outlet /> for child routes so the Layout
 * renders ONCE and stays mounted across page navigations.
 * 
 * The Layout component conditionally renders ClassicLayout (sidebar)
 * or ModernLayout (topbar) based on user preference in Settings.
 */
export function ProtectedLayout() {
  return (
    <Layout>
      <Outlet />
      {/* Onboarding modal follows users across all protected pages */}
      <OnboardingModal />
      {/* Global audio player — fixed to bottom, persists across page navigations */}
      <EnhancedAudioPlayer />
    </Layout>
  );
}
